import { render, staticRenderFns } from "./FactorizationPreview.vue?vue&type=template&id=844ac3c8&lang=pug&"
import script from "./FactorizationPreview.vue?vue&type=script&lang=js&"
export * from "./FactorizationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports